import { EPopupGroupActions } from '@r1-frontend/entities/ConnectDomruPopup/context/constants/actions';
import { TPopupGroupState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

import { IAction } from '@r1-frontend/shared/types/Redux';

export const setView = (view: TPopupGroupState): IAction<EPopupGroupActions.SetView, { view: TPopupGroupState }> => ({
    type: EPopupGroupActions.SetView,
    payload: {
        view,
    },
});
